import { render, staticRenderFns } from "./HsaAccountCard.vue?vue&type=template&id=66112645&scoped=true"
import script from "./HsaAccountCard.vue?vue&type=script&lang=ts"
export * from "./HsaAccountCard.vue?vue&type=script&lang=ts"
import style0 from "./HsaAccountCard.vue?vue&type=style&index=0&id=66112645&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66112645",
  null
  
)

export default component.exports